import { pushga, pushEcommerceGAEvent } from '@stencil/ga-utils';
import { perfUtils } from '@ibibo/performance-utils';
import dateDiff from '@stencil/flights-date-utils/src/date-diff';
import getCookie from '@stencil/flights-utils/src/get-cookie';
import isSEM from '@stencil/flights-utils/src/is-sem';
import isSEO from '@stencil/flights-utils/src/is-seo';
import isDirect from '@stencil/flights-utils/src/is-direct';
import isBING from '@stencil/flights-utils/src/is-bing';

export const gaPageViewThunk = (
  pageName,
  flightSearchDataSelector,
  pageUrl = '',
  departureDate = null
) => {
  return (dispatch, getState) => {
    const query = new window.URLSearchParams(window.location.search);
    // const expN = query.get('en') || '';
    // const expV = query.get('ev') || '';
    try {
      const flightSearchData = flightSearchDataSelector(getState());
      const {
        passengers,
        flightClass,
        source,
        destination,
        departure,
        arrival,
        journeyType,
        travelType
      } = flightSearchData;

      const virtualPage =
        window && window.location && window.location.pathname ? window.location.pathname : '';
      const depDate = departure?.yyyymmdd;
      const tdate = !departureDate
        ? `${depDate.substring(0, 4)}-${depDate.substring(4, 6)}-${depDate.substring(6)}`
        : departureDate;
      const arrDate = arrival ? arrival.yyyymmdd : null;
      const rdate = arrDate
        ? `${arrDate.substring(0, 4)}-${arrDate.substring(4, 6)}-${arrDate.substring(6)}`
        : '';

      const daysToTravel = departure ? dateDiff(new Date(), departure.dateObj) : 0;

      const data = {
        event: 'virtualPageView',
        virtualPage: pageUrl || virtualPage,
        cdCatQuery: `flight_${travelType}`,
        cdSubCatQuery: journeyType === 'ow' ? 'Oneway' : 'Roundtrip',
        cdFlightSearchOrigin: source.iata,
        ...(source?.cc ? { cdFlightSearchOriginCountry: source?.cc } : null),
        cdFlightSearchDestination:
          destination.iata || destination.cc || destination.code || destination.coc,
        ...(destination?.cc || destination.code
          ? { cdFlightSearchDestinationCountry: destination?.cc || destination.code }
          : null),
        ...(destination?.coc ? { cdFlightSearchDestinationContinent: destination?.coc } : null),
        flightRoute: `${source.iata}-${
          destination.iata || destination.cc || destination.code || destination.coc
        }`,
        cdFlightSearchDeparture: tdate,
        cdFlightSearchReturnDate: rdate,
        cdFlightSearchTravellers: passengers.adult + passengers.child + passengers.infant,
        cdFlightSearchClass: flightClass.value,
        userId: window && window.userInfo && window.userInfo.userid ? window.userInfo.userid : 0,
        pax: `${passengers.adult}-${passengers.child}-${passengers.infant}`,
        daysToTravel,
        pageName
        // ...(expN ? { exp_name: expN } : null),
        // ...(expV ? { exp_variant_id: expV } : null)
      };

      const apiLoadTime = perfUtils.markPerformanceEnd(
        'srp-thor-start',
        'srp-thor-end',
        'srp-thor-duration'
      );
      pushga({ ...data, apiLoadTime });
    } catch (err) {
      console.log(err);
    }
  };
};

export const pushPageInfoThunk = (pageInfo = null) => {
  return (dispatch, getState) => {
    try {
      const data = {
        event: 'pageInfoPushed',
        pageInfo
      };
      pushga({ ...data });
    } catch (err) {
      console.log(err);
    }
  };
};

export const gaPushPageInfoThunk = (
  pageName,
  flightSearchDataSelector,
  flavour = '',
  departureDate = null
) => {
  return (dispatch, getState) => {
    try {
      const flightSearchData = flightSearchDataSelector(getState());
      const isLoggedIn = Boolean(getCookie('OAUTH-GOIBIBO') || '');
      const {
        passengers,
        flightClass,
        source,
        destination,
        departure,
        arrival,
        travelType,
        journeyType,
        selectedFareIdentifier
      } = flightSearchData;
      const { adult, child, infant } = passengers;
      const depDate = departure?.yyyymmdd;
      const tdate = !departureDate
        ? `${depDate.substring(0, 4)}-${depDate.substring(4, 6)}${
            depDate.substring(6) && `-${depDate.substring(6)}`
          }`
        : departureDate;
      const arrDate = arrival ? arrival.yyyymmdd : null;
      const rdate = arrDate
        ? `${arrDate.substring(0, 4)}-${arrDate.substring(4, 6)}-${arrDate.substring(6)}`
        : '';

      let channel = '';
      if (isSEO()) {
        channel = 'SEO';
      } else if (isSEM()) {
        channel = 'SEM';
      } else if (isBING()) {
        channel = 'BING';
      } else if (isDirect()) {
        channel = 'Direct';
      }

      const data = {
        event: 'pageInfoPushed',
        pageInfo: {
          adltCount: adult.toString(),
          chldCount: child.toString(),
          infCount: infant.toString(),
          email: '',
          fClass: flightClass.value,
          from: source.iata,
          to: destination.iata || destination.cc || destination.code || destination.coc,
          iataSrc: source.iata,
          iataDest: destination.iata || destination.cc || destination.code || destination.coc,
          ifGoCash: '',
          pageName,
          price: '',
          tdate,
          rdate,
          sectorInf: travelType,
          siteType: flavour || window?.flavour || '',
          txnId: '',
          channel,
          totalpax: `${adult + child + infant}`,
          journey_type: journeyType,
          special_fare: selectedFareIdentifier,
          origincountry: source.cnty || source.cc || '',
          destinationcountry: destination.cnty || destination.cc || '',
          origin: source.ct,
          destination: destination.ct,
          lob: 'flight',
          usertype: isLoggedIn ? 'L' : 'G'
        }
      };
      pushga({ ...data });
    } catch (err) {
      console.log(err);
    }
  };
};

export const gaGenericEventThunk = genericEventCategory => {
  pushga({
    event: 'genericEvent',
    genericEventAction: 'PageLoad',
    genericEventCategory
  });
};

export const gaNoFlightEventThunk = (flightSearchDataSelector, noFlightEVent = null) => {
  return (dispatch, getState) => {
    if (noFlightEVent) {
      pushga(noFlightEVent);
    } else {
      const flightSearchData = flightSearchDataSelector(getState());
      const {
        passengers,
        flightClass,
        source,
        destination,
        departure,
        arrival,
        journeyType,
        travelType
      } = flightSearchData;
      const noInventoryEventData = {
        event: 'flightsNoInventory',
        cdCatQuery: 'flight_' + travelType.toLowerCase(),
        cdDaysToTravel: dateDiff(new Date(), departure.dateObj),
        cdFlightRoute: source.iata + '-' + destination.iata,
        cdFlightSearchClass: flightClass,
        cdFlightSearchDeparture: departure.yyyymmdd,
        cdFlightSearchDestination: destination.iata,
        cdFlightSearchOrigin: source.iata,
        cdFlightSearchReturnDate: arrival ? arrival.yyyymmdd : null,
        cdFlightSearchTravellers: passengers.adult + passengers.child + passengers.infant,
        cdSubCatQuery: journeyType === 'rt' ? 'Roundtrip' : 'Oneway',
        ABVariation: window.AB ? window.AB : 0
      };
      window.dataLayer.push(noInventoryEventData);
    }
  };
};

export function pushGapImpressions(
  filteredAndSortedDisplayOnwardFlights,
  filteredAndSortedDisplayReturnFlights,
  flightSearchDataSelector,
  displayAlternateTimeFlightsLengthSelector
) {
  return (dispatch, getState) => {
    const onwardFlights = filteredAndSortedDisplayOnwardFlights(getState());
    const returnFlights = filteredAndSortedDisplayReturnFlights(getState());
    const alternateLocationFlightsLength = displayAlternateTimeFlightsLengthSelector(getState());

    const flightSearchData = flightSearchDataSelector(getState());
    const {
      passengers,
      flightClass,
      source,
      destination,
      departure,
      arrival,
      journeyType,
      travelType
    } = flightSearchData;

    const impressionsOnwFlts = [];
    const impressionsRetFlts = [];
    const userEmail = window?.userInfo?.email || '';
    const loopCountOnw = onwardFlights.length > 75 ? 75 : onwardFlights.length;
    const loopCountRet = returnFlights.length > 75 ? 75 : returnFlights.length;
    // const noInventoryEventData = {
    //   event: 'flightsNoInventory',
    //   cdCatQuery: 'flight_' + travelType.toLowerCase(),
    //   cdDaysToTravel: dateDiff(new Date(), departure.dateObj),
    //   cdFlightRoute: source.iata + '-' + destination.iata,
    //   cdFlightSearchClass: flightClass,
    //   cdFlightSearchDeparture: departure.yyyymmdd,
    //   cdFlightSearchDestination: destination.iata,
    //   cdFlightSearchOrigin: source.iata,
    //   cdFlightSearchReturnDate: arrival ? arrival.yyyymmdd : null,
    //   cdFlightSearchTravellers: passengers.adult + passengers.child + passengers.infant,
    //   cdSubCatQuery: journeyType === 'rt' ? 'Roundtrip' : 'Oneway',
    //   ABVariation: window.AB ? window.AB : 0
    // };

    if (alternateLocationFlightsLength > 0) {
      window.dataLayer.push({
        event: 'FltHpyDisplay',
        eventName: 'AlternateDayFlightsDisplay',
        selectedEventOption: alternateLocationFlightsLength,
        userEmail: userEmail,
        ABVariation: window.AB ? window.AB : 0
      });
    }
    // if (onwardFlights.length === 0) {
    //   window.dataLayer.push(noInventoryEventData);
    // }

    for (let i = 0; i < loopCountOnw; i++) {
      const fltImpression = {};
      const onwFlt = onwardFlights[i];
      fltImpression.brand = onwFlt.carrierNameArr[0];

      onwFlt.carrierNameArr.forEach((brand, index) => {
        if (index > 0) {
          fltImpression.brand += '|' + brand;
        }
      });

      fltImpression.category = 'flight_' + travelType.toLowerCase();
      fltImpression.id = 'flight';
      fltImpression.name = 'flight';

      onwFlt.flightArr.forEach(flt => {
        fltImpression.id +=
          '|' + flt.flightNumber + '|' + flt.depTime + '|' + flt.depCode + '_' + flt.arrCode;
        fltImpression.name = '|' + flt.depCode + '-' + flt.arrCode;
      });

      fltImpression.position = i + 1;
      fltImpression.price = parseInt(onwFlt.price.replace(',', ''), 10);
      fltImpression.variant =
        'flight|' + travelType + (journeyType === 'rt' ? 'Roundtrip' : 'Oneway');
      fltImpression.list = 'flight|Search_Results';

      impressionsOnwFlts[i] = fltImpression;
    }
    window.dataLayer.push({
      ecommerce: {
        impressions: impressionsOnwFlts
      },
      event: 'enhanced-ecommerce-srp',
      weEmail: userEmail,
      path: location.pathname,
      ABVariation: window.AB ? window.AB : 0
    });

    if (loopCountRet > 0) {
      for (let i = 0; i < loopCountRet; i++) {
        const retFltImpression = {};
        const retFlt = returnFlights[i];
        retFltImpression.brand = retFlt.carrierNameArr[0];

        retFlt.carrierNameArr.forEach((brand, index) => {
          if (index > 0) {
            retFltImpression.brand += '|' + brand;
          }
        });

        retFltImpression.category = 'flight_' + travelType.toLowerCase();
        retFltImpression.id = 'flight';
        retFltImpression.name = 'flight';

        retFlt.flightArr.forEach(flt => {
          retFltImpression.id +=
            '|' + flt.flightNumber + '|' + flt.depTime + '|' + flt.depCode + '_' + flt.arrCode;
          retFltImpression.name = '|' + flt.depCode + '-' + flt.arrCode;
        });

        retFltImpression.position = i + 1;
        retFltImpression.price = parseInt(retFlt.price.replace(',', ''), 10);
        retFltImpression.variant =
          'flight|' + travelType + (journeyType === 'rt' ? 'Roundtrip' : 'Oneway');
        retFltImpression.list = 'flight|Search_Results';

        impressionsRetFlts[i] = retFltImpression;
      }

      window.dataLayer.push({
        ecommerce: {
          impressions: impressionsRetFlts
        },
        event: 'enhanced-ecommerce-srp',
        weEmail: userEmail,
        path: location.pathname,
        ABVariation: window.AB ? window.AB : 0
      });
    }
  };
}

export const pushGAEcommerceEvent = (eventName, products, actionFieldObj) => {
  const action = { ...actionFieldObj, affiliation: 'goibibo', shipping: '', tax: '' };
  pushEcommerceGAEvent({
    event: eventName,
    ecommerce: {
      purchase: {
        actionField: action,
        products
      }
    }
  });
};

export const pushNPSGAEvents = (event, screen_name, lob = '', feedbackRating = '') => {
  pushga({
    event,
    ...(lob && { screen_name: screen_name + lob }),
    ...(feedbackRating && { item_selected: feedbackRating + 'star' })
  });
};
